"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateHelper = exports.initialState = exports.default = void 0;
var _QuizQuestionStateHelper = _interopRequireDefault(require("../helpers/QuizQuestionStateHelper.js"));
var _Response = _interopRequireDefault(require("../factories/Response.js"));
var _dateTime = require("../helpers/dateTime.js");
var _constants = require("../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var stateHelper = exports.stateHelper = new _QuizQuestionStateHelper.default(_Response.default);
var initialState = stateHelper.initialState;
exports.initialState = initialState;
var reducers = {};
reducers[_constants.QUIZ_FETCHED_TAKE] = stateHelper.set;
reducers[_constants.QUIZ_RESPONSES_FETCHED] = stateHelper.set;
reducers[_constants.QUIZ_UNLOAD_QUESTIONS_AND_RESPONSES] = function (state, payload) {
  var quizId = payload.quizId;
  return state.delete(quizId);
};
reducers[_constants.QUIZ_FETCHED_QUESTIONS] = stateHelper.set;
reducers[_constants.QUIZ_SUBMITTED] = stateHelper.set;
reducers[_constants.QUIZ_UNLOAD_TAKE] = stateHelper.reset;
reducers[_constants.QUIZ_CREATING] = stateHelper.reset;
reducers[_constants.OFFLINE_QUIZ_LOADED] = function responseLoadOffline(state, payload) {
  var quizId = payload.quizId,
    responses = payload.responses;
  if (!responses) {
    return state;
  }
  return state.setIn([quizId], responses);
};
reducers[_constants.RESPONSE_SYNCED] = stateHelper.set;
reducers[_constants.RESPONSE_EVALUATED] = stateHelper.set;
reducers[_constants.RESPONSE_TIME_UPDATED] = function responseTimeUpdated(state, payload) {
  var quizId = payload.quizId,
    questionId = payload.questionId;
  var response = state.get([quizId, questionId]);
  if (!response) {
    return stateHelper.set(state, payload);
  }
  return state.setIn([quizId, questionId, 'ms_spent'], payload.data.attributes.ms_spent);
};
reducers[_constants.RESPONSE_SET] = function responseSet(state, payload) {
  var quizId = payload.quizId,
    questionId = payload.questionId,
    response = payload.response;
  return state.setIn([quizId, questionId], response);
};
reducers[_constants.RESPONSE_EVALUATE_LOCAL] = function responseEvaluateLocal(state, payload) {
  var quizId = payload.quizId,
    questionId = payload.questionId,
    correct = payload.correct,
    ungraded_correct = payload.ungraded_correct;
  if (ungraded_correct !== undefined) {
    return state.setIn([quizId, questionId, 'ungraded_correct'], ungraded_correct).setIn([quizId, questionId, 'synced'], false);
  }
  return state.setIn([quizId, questionId, 'correct'], correct).setIn([quizId, questionId, 'evaluated_at'], (0, _dateTime.getServerTimeNow)()).setIn([quizId, questionId, 'synced'], false);
};
reducers[_constants.ASSIGNMENT_RESPONSES_FETCHED] = function assignmentResponsesPerformance(state, payload) {
  return state.withMutations(function (newState) {
    payload.list.forEach(function (assignmentResponses) {
      newState.set(assignmentResponses.id, new _Response.default({
        id: assignmentResponses.id,
        attributes: {
          status: assignmentResponses.status,
          time: assignmentResponses.time,
          potential_score: parseInt(assignmentResponses.potential_score),
          actual_score: parseInt(assignmentResponses.actual_score)
        },
        relationships: {
          user: {
            data: {
              id: assignmentResponses.user_id
            }
          },
          quiz: {
            data: {
              id: assignmentResponses.quiz_id
            }
          },
          question: {
            data: {
              id: assignmentResponses.question_id
            }
          }
        }
      }));
    });
  });
};
var _default = exports.default = stateHelper.createReducer(reducers);